/**
 * Utilities that deal with address, leveraging client-side Griffin 🎉
 */
import griffinAddress from 'griffin-paypal/address'
import getGriffinMetadata from './griffin-utils'

/**
 * Get the supported currency pattern for specific style for the current locale
 * @param  {Object} address griffin portable address object
 * @return {String} the address into single line
 */

export function formatAddressToSingleLine(address: Object) {
  const griffinMetadata = getGriffinMetadata()
  const griffinHandler = griffinAddress.createHandler(griffinMetadata)

  try {
    const result = griffinHandler.formatAddress(address, {
      style: griffinHandler.ADDRESS_FORMAT_DISPLAY_SINGLE,
    })
    if (typeof result === 'string') {
      return result
    }
    throw result
  } catch (error) {
    // for error scenario griffin returns an error object so this fn must return empty string to downstream
    window.onerror('griffin::formatAddressToSingleLine', '', 0, 0, error)
    return ''
  }
}
